enum UploadingStatusTypes {
  OFF = 'Offgg',
  PENDING = 'Pending',
  UPLOADING = 'Uploading',
  COMPLETE = 'Complete',
}

export default UploadingStatusTypes